export default __webpack_public_path__ + "static/bg-catalog-request-demo-2054e348687bbf413625e11f48c2e29b.png";